/* __next_internal_client_entry_do_not_use__ Globals auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @faire/ssr-no-restricted-globals */ import { scopedSingletonGetter } from "@faire/retailer-visitor-shared/app/_lib/scopedSingletonGetter";
import { SSRRequestLocalStorage } from "@faire/retailer-visitor-shared/app/_lib/SSRRequestLocalStorage";
import { LOCAL_PORT } from "@faire/web--source/common/routes/faireBaseUrl";
import { faireBaseUrlMatcher } from "@faire/web--source/common/routes/faireBaseUrlMatcher";
import { handleHydrationCompleted } from "@faire/web--source/common/server-side-rendering/isSSR";
import { createMemoryHistory } from "history";
import React, { useLayoutEffect, useRef } from "react";
import { init as initializeWebApi } from "@faire/retailer-visitor-shared/initialize/web-api";
export var Globals = function(param) {
    var children = param.children, globals = param.globals, memoryHistory = param.memoryHistory, userAgent = param.userAgent, referer = param.referer, originalUrl = param.originalUrl;
    var didInit = useRef(false);
    useLayoutEffect(function() {
        // We need to call this in a layout effect to notify our code that Hydration
        // finished and code can start using client side value. One example is
        // ObservableWindow
        handleHydrationCompleted();
    }, []);
    if ("object" === "undefined") {
        // Use the location according to the Faire backend, not according to Next.js.
        // Some differences: Next.js always includes a URL and doesn't ever end in a slash.
        var url = new URL("/", faireBaseUrlMatcher(globals.envName, "retailer"));
        try {
            if (originalUrl) {
                url = new URL(originalUrl);
            } else {
                // eslint-disable-next-line no-console
                console.error("originalUrl is undefined");
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error parsing originalUrl", {
                originalUrl: originalUrl,
                error: e
            });
        }
        if (globals.envName === "local") {
            // To avoid hydration errors, we need to set the URL to localhost instead of staging
            // during local development.
            url = new URL("".concat(url.pathname).concat(url.search), "http://localhost:".concat(LOCAL_PORT.retailer));
        }
        var reactRouterLocation = createMemoryHistory({
            initialEntries: [
                "".concat(url.pathname).concat(url.search)
            ]
        }).location;
        var location = _object_spread({
            href: url.href,
            hostname: url.hostname,
            host: url.host,
            origin: url.origin,
            port: url.port,
            protocol: url.protocol,
            ancestorOrigins: [],
            assign: function() {},
            reload: function() {},
            replace: function() {}
        }, reactRouterLocation);
        // Note that since this is rendered on the server, this will not be
        // rerendered. Recreating the globals on the client every render wouldn't
        // necessarily be safe.
        return /*#__PURE__*/ _jsx(SSRRequestLocalStorage.Provider, {
            value: {
                global: _object_spread_props(_object_spread({}, globals), {
                    isSSR: true,
                    isNextJS: true,
                    needToHydrate: true,
                    location: location,
                    memoryHistory: memoryHistory,
                    window: {
                        location: location,
                        navigator: {
                            userAgent: userAgent
                        },
                        document: {
                            referrer: referer !== null && referer !== void 0 ? referer : ""
                        },
                        addEventListener: function() {}
                    },
                    faire: {
                        singletons: {
                            getter: scopedSingletonGetter
                        },
                        api: {
                            // TODO(jocelyn): We probably don't actually want to silently resolve fetches,
                            // but we currently assume that fetches work (e.g., when assigning).
                            // Investigate and consider removing.
                            handler: function() {
                                return Promise.resolve();
                            }
                        },
                        app: "web-retailer"
                    }
                })
            },
            children: children
        });
    } else {
        // This isn't an effect, because we need this to run before any other
        // code. (Please don't copy this code into other files, this is a hack.)
        if (!didInit.current) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(globals)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    // @ts-expect-error -- These are globals (we want to get rid of globals).
                    // Note that "faire" is initialized earlier, in `indexHead.ts`.
                    if (key !== "faire" || !window[key]) {
                        // @ts-expect-error -- These are globals (we want to get rid of globals).
                        window[key] = value; // eslint-disable-line react-compiler/react-compiler
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            didInit.current = true;
            // @ts-expect-error -- These are globals (we want to get rid of globals).
            window["isNextJS"] = true;
            // @ts-expect-error -- These are globals (we want to get rid of globals).
            window["cache"] = {};
            initializeWebApi();
            didInit.current = true;
        }
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
};
